// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__37NyU","danger":"style_danger__6TTbN","small":"style_small__EbVaA"};